/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import Speed20Icon from "@/src/assets/icons/traffic/toggleable/IconSpeedZeroToTwentyKmH";
import Speed30Icon from "@/src/assets/icons/traffic/toggleable/IconSpeedTwentyOneToThirtyKmH";
import Speed40Icon from "@/src/assets/icons/traffic/toggleable/IconSpeedThirtyOneToFortyKmH";
import Speed40OverIcon from "@/src/assets/icons/traffic/toggleable/IconSpeedMoreThanFortyKmH";
import QuestionIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "@/src/services/translations/translations";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

export default function SpeedingSpeed({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="speeding"
                question={translate("traffic.speeding.label", values)}
                options={[
                  {
                    labelText: translate("traffic.speeding.options.0-20.label", values),
                    labelIcon: <Speed20Icon />,
                    labelIconActive: <Speed20Icon active />,
                    value: "0-20",
                  },
                  {
                    labelText: translate("traffic.speeding.options.21-30.label", values),
                    labelIcon: <Speed30Icon />,
                    labelIconActive: <Speed30Icon active />,
                    value: "21-30",
                  },
                  {
                    labelText: translate("traffic.speeding.options.31-40.label", values),
                    labelIcon: <Speed40Icon />,
                    labelIconActive: <Speed40Icon active />,
                    value: "31-40",
                  },
                  {
                    labelText: translate("traffic.speeding.options.>40.label", values),
                    labelIcon: <Speed40OverIcon />,
                    labelIconActive: <Speed40OverIcon active />,
                    value: ">40",
                  },
                  {
                    labelText: translate("traffic.speeding.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
